import { render, staticRenderFns } from "./VolunteergiftsCompile.vue?vue&type=template&id=155b41b1&scoped=true"
import script from "./VolunteergiftsCompile.vue?vue&type=script&lang=js"
export * from "./VolunteergiftsCompile.vue?vue&type=script&lang=js"
import style0 from "./VolunteergiftsCompile.vue?vue&type=style&index=0&id=155b41b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b41b1",
  null
  
)

export default component.exports